import {
  DraftQuestionnaireEntry,
  EntryType,
  QuestionSettingCode
} from '../../../data/model/questionnaire'
import { hasFeatureAccess } from '../../../utils/authUtils'
import QuestionCardSwitches from '../QuestionCardSwitches'

export const MatrixQuestionRowsSwitches = ({
  entry
}: {
  entry: DraftQuestionnaireEntry<EntryType.MatrixEntryType>
}) => {
  return (
    <QuestionCardSwitches
      entry={entry}
      randomiseQuestionSettingCode={QuestionSettingCode.MatrixRandomiseRows}
      hasMobileViewOnlySwitch={hasFeatureAccess('MatrixMobileViewOnly')}
      title="ROWS"
    />
  )
}
